export default "__VITE_ASSET__FQW03UAZ__"